import React from "react";
import { 
  StatusActiveIcon, 
  StatusArchivedIcon, 
  StatusClosedIcon, 
  StatusPlanningIcon 
} from "../../../../assets/icons/icons";

type Props = { 
  color?: string; 
  status?: string;
  className?: string;
  style?: React.CSSProperties;
};

export default function StatusIndicator({ status, className, style }: Props) {
  const getStatusIcon = () => {
    const normalizedStatus = status?.toLowerCase();
    switch (normalizedStatus) {
      case "active":
        return StatusActiveIcon;
      case "closed":
        return StatusClosedIcon;
      case "planning":
        return StatusPlanningIcon;
      case "archived":
        return StatusArchivedIcon;
      default:
        return StatusActiveIcon; // fallback
    }
  };

  const IconComponent = getStatusIcon();

  return (
    <IconComponent 
      className={className}
      style={{ width: 20, height: 20, ...style }}
    />
  );
}
